import type { components } from 'gtsongsapi/schema'
import { SongDetailed,SongVersion } from 'gtsongsapi/types'

type CapoPosition = components['schemas']['CapoPosition']

export const getCapoPosition = (
  song: SongDetailed,
  version: SongVersion,
): number => {
  if (!song?.transcription?.data?.capo_position) return 0

  const versionKey = version as keyof CapoPosition
  const position = song.transcription.data.capo_position[versionKey]
  return typeof position === 'number' ? position : 0
}
